import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type Totals = {
  totalAllocated: number;
  totalUsed: number;
  totalPending: number;
  totalBalance: number;
};

export type Breakdown = {
  _id: any;
  totalAnnualAllocated?: number;
  totalAnnualUsed?: number;
  totalAnnualPending?: number;
  totalAnnualBalance?: number;
  totalSickAccrued?: number;
  totalSickUsed?: number;
  totalSickPending?: number;
  totalSickBalance?: number;
  totalPressAllocated?: number;
  totalPressUsed?: number;
  totalPressPending?: number;
  totalPressBalance?: number;
  totalOtherUsed?: number;
  totalOtherPending?: number;
};

export type LeaveSummaryResponse = {
  success: boolean;
  year: number;
  organization: string;
  totalUsers: number;
  totals: Totals;
  breakdown: Breakdown;
  message?: string;
};

const fetchLeaveSummary = async (
  id: string | number
): Promise<LeaveSummaryResponse> => {
  const url = `/leaves/summary/${id}`;
  const { data } = await customAxios.get<LeaveSummaryResponse>(url);
  return data;
};

export const useGetLeaveSummary = (id: string | number) =>
  useQuery<LeaveSummaryResponse, AxiosError>(
    ["leaveSummary", id],
    () => fetchLeaveSummary(id),
    {
      // onError: (error) =>
      //   showNotification({
      //     title: "Error Loading Leave Summary",
      //     message:
      //       (error.response?.data as { message?: string })?.message ??
      //       "Failed to load leave summary",
      //     color: "red",
      //   }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
